module.exports = __webpack_public_path__ + "img/tigognshangmenzhujie_icon_zj.6e9d4abe.png";